export default __webpack_public_path__ + "static/media/dotnet.1ec6cf54.svg";